export const ZONES = [
  { name: "Downtown Core", pos: [51.0463, -114.0653], live: true, eta: "14–20 min" },
  { name: "Beltline", pos: [51.0392, -114.0728], live: true, eta: "15–20 min" },
  { name: "Mission", pos: [51.0264, -114.0687], live: true, eta: "18–24 min" },
  { name: "Kensington", pos: [51.0524, -114.09], live: true, eta: "16–22 min" },
  { name: "Bridgeland", pos: [51.0524, -114.0355], live: true, eta: "17–23 min" },
  { name: "Brentwood", pos: [51.087, -114.122], live: true, eta: "20–28 min" },
  { name: "Inglewood", pos: [51.0382, -114.0308], live: false },
  { name: "Marda Loop", pos: [51.025, -114.103], live: false },
  { name: "University District", pos: [51.0765, -114.1445], live: false },
  { name: "Killarney", pos: [51.03, -114.125], live: false },
];

export const LIVE_ZONES = ZONES.filter((z) => z.live);
export const SOON_ZONES = ZONES.filter((z) => !z.live);
